import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Box, Typography } from "@mui/material";

type Props = {
	projectedRollOut: Date | null;
	projectedBreakin: Date | null;
};

const format = (d: Date | null) =>
	d ? dxtToLocalServerTime(d, "MM/dd HH:mm") : "-";

// Issue #250: projected rollout / break-in shown next to the scheduled variance.
export const ProjectedTimes = ({
	projectedRollOut,
	projectedBreakin,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			flexDirection: "column",
			gap: 0.25,
			mt: "auto",
			pt: 1.5,
		}}
	>
		<Typography
			variant="caption"
			sx={{
				color: "#666",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "baseline",
			}}
			fontSize={12}
		>
			<em>Projected Rollout Time:</em>
			<span style={{ color: "#d32f2f", fontWeight: 500 }}>
				{format(projectedRollOut)}
			</span>
		</Typography>
		<Typography
			variant="caption"
			sx={{
				color: "#666",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "baseline",
			}}
			fontSize={12}
		>
			<em>Projected Break In:</em>
			<span style={{ color: "#d32f2f", fontWeight: 500 }}>
				{format(projectedBreakin)}
			</span>
		</Typography>
	</Box>
);
